export function stripNullish<T extends object> (obj: T): T {
    return Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v != null)
    ) as T
}
